<template>
  <my-view :SingleGetOrderInfoToPay="SingleGetOrderInfoToPay" :SingleGetOrderPayFeeInfo="SingleGetOrderPayFeeInfo" :SinglePageOrderPay="SinglePageOrderPay"></my-view>
</template>

<script>
import {
  SingleGetOrderInfoToPay,
  SingleGetOrderPayFeeInfo,
  SinglePageOrderPay,
} from "@/pages/page1/api/modules/order";

import MyView from "@/pages/publicView/paymentProcess/payType/orderPay_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      SingleGetOrderInfoToPay,
      SingleGetOrderPayFeeInfo,
      SinglePageOrderPay,
    };
  },
};
</script>